import type { Workspace } from '@rhia/protocol';
import { createContext, type PropsWithChildren, useContext } from 'react';
import { useWorkspaceBySlug } from './api';

const WorkspaceCtx = createContext<Workspace | null>(null);

export function WorkspaceProvider({ slug, children }: PropsWithChildren<{ slug: string }>) {
  const { data, isPending, error } = useWorkspaceBySlug(slug);
  if (isPending) {
    return <div className="p-6 text-sm text-[color:var(--color-fg)]/60">loading workspace…</div>;
  }
  if (error) {
    return (
      <div className="p-6 text-sm text-[color:var(--color-danger)]">
        error loading workspace: {error.message}
      </div>
    );
  }
  if (!data) {
    return (
      <div className="p-6 text-sm text-[color:var(--color-danger)]">
        Workspace "{slug}" not found.
      </div>
    );
  }
  return <WorkspaceCtx.Provider value={data}>{children}</WorkspaceCtx.Provider>;
}

export function useCurrentWorkspace(): Workspace {
  const ws = useContext(WorkspaceCtx);
  if (!ws) {
    throw new Error('useCurrentWorkspace must be used inside a <WorkspaceProvider>');
  }
  return ws;
}
